import { Option } from '../../general-types';
import { ValueOfKey } from '../../utils-types';

// use getHumanizeReleaseStatus utils to get showed name

export const RELEASE_STATUS = {
  UPCOMING: 'UPCOMING',
  RELEASED: 'RELEASED',
} as const;

export type ReleaseStatusType = ValueOfKey<typeof RELEASE_STATUS>;

export const humanizeReleaseStatus: Record<ReleaseStatusType, string> = {
  UPCOMING: 'Upcoming',
  RELEASED: 'Released',
};

export const statusFilterOptions: Option<ReleaseStatusType>[] = [
  { label: 'Upcoming', value: 'UPCOMING' },
  { label: 'Released', value: 'RELEASED' },
];
